import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/premiumToast";   // v101.175.0 · mensajes premium + tarjeta de proceso de integraciones
import App from "@/App";

// Polyfills mínimos para navegadores antiguos (Safari 13, iOS 13, etc.)
// Usar sólo si no existen — no rompe navegadores modernos.
if (typeof Array.prototype.at !== "function") {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function (n) {
    n = Math.trunc(n) || 0;
    if (n < 0) n += this.length;
    if (n < 0 || n >= this.length) return undefined;
    return this[n];
  };
}
if (typeof Object.hasOwn !== "function") {
  Object.hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
}
if (typeof String.prototype.replaceAll !== "function") {
  // eslint-disable-next-line no-extend-native
  String.prototype.replaceAll = function (str, replace) {
    if (Object.prototype.toString.call(str).toLowerCase() === "[object regexp]") {
      return this.replace(str, replace);
    }
    return this.replace(new RegExp(str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"), replace);
  };
}

// Detección de navegador incompatible → mostrar aviso amable
try {
  const ua = navigator.userAgent || "";
  const isIE = /MSIE |Trident\//.test(ua);
  if (isIE) {
    document.body.innerHTML = `
      <div style="font-family:system-ui,sans-serif;padding:2rem;max-width:600px;margin:2rem auto;background:#FEF2F2;border:2px solid #DC2626;border-radius:12px">
        <h1 style="color:#DC2626;margin-top:0">Navegador no compatible</h1>
        <p>Alfa-Field Connect requiere un navegador moderno. Por favor actualiza a:</p>
        <ul><li>Chrome 80+</li><li>Firefox 78+</li><li>Edge 80+</li><li>Safari 13+</li></ul>
      </div>`;
    throw new Error("Unsupported browser: IE");
  }
} catch (e) { /* seguir */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
